export const app = {
  connectToYourWhatsappNumber: 'Verbinden met je WhatsApp-nummer',
  connectYourWhatsappBotWithYourWhatsappNumber: 'Verbind je WhatsApp-bot met je WhatsApp-nummer',
  connect: 'Verbinden',
};
